import { useMemo } from 'react'
import { TableContextValue } from './useTableContext'

const useTableContextValue = ({
  idObjectClass,
  objectclass,
  fields,
  actionColumns,
  actionColumnsPosition,
  columnsNames,
  objects,
  refetchObjects,
  columnsLayouts,
  onSort,
  sortOptions,
  currentColumnIndex,
  totalColumns,
  amountOfFixedColumns,
  pagination,
  totalObjects,
  layoutClassificationUuid,
  hierarchyLevel,
  actionButton,
  selectedRows,
  setSelectedRows,
  mode,
  setMode,
  changedFieldValues,
  setChangedFieldValues,
  relationCounterpartField,
  objectclassQueryString,
  displayLayoutSelection,
  informational,
  embedded,
  navigationSliderBackgroundColor,
  navigationSliderColor,
  concatFields,
  hideRowActionButtons,
  hideSortButtons,
  hideEditAction,
  onChangeColumnsPage,
  amountOfActionColumns,
  customActionButtons,
  allColumns,
  selectAndLinkOptions,
  primarySelectionAction,
  isShowPDFReports,
  isShowXLSReport,
  extraSelectionActions,
  disableLinkButton,
  allowHighlightSelectedRow
}: TableContextValue): TableContextValue => {
  return useMemo(
    () => ({
      idObjectClass,
      objectclass,
      fields,
      actionColumns,
      actionColumnsPosition,
      columnsNames,
      objects,
      refetchObjects,
      columnsLayouts,
      onSort,
      sortOptions,
      currentColumnIndex,
      totalColumns,
      pagination,
      totalObjects,
      layoutClassificationUuid,
      hierarchyLevel,
      actionButton,
      selectedRows,
      setSelectedRows,
      mode,
      setMode,
      changedFieldValues,
      setChangedFieldValues,
      relationCounterpartField,
      objectclassQueryString,
      displayLayoutSelection,
      informational,
      embedded,
      navigationSliderBackgroundColor,
      navigationSliderColor,
      concatFields,
      amountOfFixedColumns,
      hideRowActionButtons,
      hideSortButtons,
      hideEditAction,
      onChangeColumnsPage,
      amountOfActionColumns,
      customActionButtons,
      allColumns,
      selectAndLinkOptions,
      primarySelectionAction,
      isShowPDFReports,
      isShowXLSReport,
      extraSelectionActions,
      disableLinkButton,
      allowHighlightSelectedRow
    }),
    [
      idObjectClass,
      objectclass,
      fields,
      actionColumns,
      actionColumnsPosition,
      columnsNames,
      objects,
      refetchObjects,
      columnsLayouts,
      onSort,
      sortOptions,
      currentColumnIndex,
      totalColumns,
      pagination,
      totalObjects,
      layoutClassificationUuid,
      hierarchyLevel,
      actionButton,
      selectedRows,
      setSelectedRows,
      mode,
      setMode,
      changedFieldValues,
      setChangedFieldValues,
      relationCounterpartField,
      objectclassQueryString,
      displayLayoutSelection,
      informational,
      embedded,
      navigationSliderBackgroundColor,
      navigationSliderColor,
      concatFields,
      amountOfFixedColumns,
      hideRowActionButtons,
      hideSortButtons,
      hideEditAction,
      onChangeColumnsPage,
      amountOfActionColumns,
      customActionButtons,
      allColumns,
      selectAndLinkOptions,
      primarySelectionAction,
      isShowPDFReports,
      isShowXLSReport,
      extraSelectionActions,
      disableLinkButton,
      allowHighlightSelectedRow
    ]
  )
}

export default useTableContextValue
